import styled, { css } from 'styled-components/macro';

import { definitionLabel } from 'styles/base-classes';
import { Label } from 'components/data-visualization/LineChart/shared.style';

export const Figure = styled.figure`
  margin: 0;
`;

export const FigCaption = styled.figcaption`
  ${definitionLabel};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

export const Tick = styled(Label)`
  text-transform: none;
`;

export const TickLine = styled.line<any>`
  stroke: ${({ theme }) => theme.Grey};
  stroke-width: 1;

  ${({ isDashed }) =>
    isDashed &&
    css`
      stroke-dasharray: 1 3;
      stroke-linecap: round;
    `};
`;
